import { useState, useEffect, useRef } from "react";

// ============================================================
// DİL SİSTEMİ
// ============================================================
const T = {
  TR: {
    appName:"Girne Temizlik", login:"Giriş Yap", phone:"Telefon No", password:"Şifre",
    loginTitle:"Hoş Geldiniz", loginSub:"Sakin panelinize giriş yapın",
    messages:"Mesajlar", dues:"Aidatım", expenses:"Harcamalar",
    complaints:"Şikayet & Görüş", announcements:"Duyurular", faults:"Arıza Bildir",
    send:"Gönder", typeMsg:"Mesajınızı yazın...", groupChat:"Grup sohbeti",
    allResidents:"Tüm sakinler", paid:"Ödendi", pending:"Bekliyor", late:"Gecikti",
    totalPaid:"Toplam Ödenen", totalExpense:"Toplam Harcama",
    suggestion:"Öneri", complaint:"Şikayet", opinion:"Görüş", sendTo:"Yönetime İlet",
    records:"Kayıtlar", newRecord:"+ Yeni İlet", title:"Başlık", content:"Açıklama",
    emergency:"Acil Durum", close:"Kapat",
    faultTitle:"Arıza Başlığı", faultDesc:"Arıza Açıklaması", faultLocation:"Konum",
    faultForm:"Arıza Bildirimi", submitFault:"Arıza Bildir", faultSent:"Arıza bildiriminiz iletildi!",
    statusNew:"Yeni", statusProgress:"Devam Ediyor", statusDone:"Çözüldü",
    adminNote:"Yönetici Notu", viewFile:"Görüntüle",
    noAnnouncement:"Duyuru yok", block:"Blok", apartment:"Daire", logout:"Çıkış",
    profileEdit:"Profili Düzenle", saveChanges:"Değişiklikleri Kaydet",
    noDebt:"Borcunuz Yok", totalDebt:"Toplam Ödenmemiş Borç",
    onlinePayment:"Online Öde", paymentDone:"Ödemeyi Tamamladım",
    confirmLogout:"Çıkış yapmak istediğinize emin misiniz?",
  },
  EN: {
    appName:"Girne Temizlik", login:"Login", phone:"Phone Number", password:"Password",
    loginTitle:"Welcome", loginSub:"Login to your resident panel",
    messages:"Messages", dues:"My Dues", expenses:"Expenses",
    complaints:"Complaints & Suggestions", announcements:"Announcements", faults:"Report Fault",
    send:"Send", typeMsg:"Type a message...", groupChat:"Group chat",
    allResidents:"All residents", paid:"Paid", pending:"Pending", late:"Overdue",
    totalPaid:"Total Paid", totalExpense:"Total Expenses",
    suggestion:"Suggestion", complaint:"Complaint", opinion:"Opinion", sendTo:"Send to Manager",
    records:"Records", newRecord:"+ New", title:"Title", content:"Description",
    emergency:"Emergency", close:"Close",
    faultTitle:"Fault Title", faultDesc:"Fault Description", faultLocation:"Location",
    faultForm:"Fault Report", submitFault:"Submit Report", faultSent:"Fault report submitted!",
    statusNew:"New", statusProgress:"In Progress", statusDone:"Resolved",
    adminNote:"Manager Note", viewFile:"View",
    noAnnouncement:"No announcements", block:"Block", apartment:"Apt", logout:"Logout",
    profileEdit:"Edit Profile", saveChanges:"Save Changes",
    noDebt:"No Outstanding Debt", totalDebt:"Total Outstanding Debt",
    onlinePayment:"Pay Online", paymentDone:"I Completed Payment",
    confirmLogout:"Are you sure you want to logout?",
  },
  RU: {
    appName:"Girne Temizlik", login:"Войти", phone:"Номер телефона", password:"Пароль",
    loginTitle:"Добро пожаловать", loginSub:"Войдите в панель жильца",
    messages:"Сообщения", dues:"Мои взносы", expenses:"Расходы",
    complaints:"Жалобы и предложения", announcements:"Объявления", faults:"Сообщить о поломке",
    send:"Отправить", typeMsg:"Написать сообщение...", groupChat:"Групповой чат",
    allResidents:"Все жильцы", paid:"Оплачено", pending:"Ожидание", late:"Просрочено",
    totalPaid:"Итого оплачено", totalExpense:"Итого расходов",
    suggestion:"Предложение", complaint:"Жалоба", opinion:"Мнение", sendTo:"Отправить управляющему",
    records:"Записи", newRecord:"+ Новая", title:"Заголовок", content:"Описание",
    emergency:"Экстренный вызов", close:"Закрыть",
    faultTitle:"Название неисправности", faultDesc:"Описание", faultLocation:"Место",
    faultForm:"Сообщение о неисправности", submitFault:"Отправить", faultSent:"Заявка отправлена!",
    statusNew:"Новая", statusProgress:"В работе", statusDone:"Решено",
    adminNote:"Примечание управляющего", viewFile:"Открыть",
    noAnnouncement:"Объявлений нет", block:"Подъезд", apartment:"Кв", logout:"Выйти",
    profileEdit:"Редактировать профиль", saveChanges:"Сохранить изменения",
    noDebt:"Долгов нет", totalDebt:"Общая задолженность",
    onlinePayment:"Оплатить онлайн", paymentDone:"Оплата выполнена",
    confirmLogout:"Вы уверены, что хотите выйти?",
  },
};

// ============================================================
// MOCK DATA (fallback)
// ============================================================
// ============================================================
// SUPABASE HELPERS — Tüm veri Supabase'den gelir
// ============================================================
const SUPA_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPA_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Belirli ay/yıl için dönem aidat tutarını tarihe göre bul
function getDönemTutariSP(aidatTarihleri, siteId, ayKey, fallback) {
  if (!aidatTarihleri || !aidatTarihleri.length) return fallback || 0;
  const [yStr, mStr] = ayKey.split("-");
  const tarih = new Date(parseInt(yStr), parseInt(mStr) - 1, 15);
  const liste = aidatTarihleri
    .filter(a => a.siteId === siteId)
    .filter(a => {
      const bas = new Date(a.baslangicTarihi);
      const bit = a.bitisTarihi ? new Date(a.bitisTarihi) : new Date("2099-12-31");
      return tarih >= bas && tarih <= bit;
    })
    .sort((a, b) => new Date(b.baslangicTarihi) - new Date(a.baslangicTarihi));
  return liste.length > 0 ? Number(liste[0].tutar) : (fallback || 0);
}

async function supabaseVeriCek() {
  if (!SUPA_URL || !SUPA_KEY) return null;
  try {
    const res = await fetch(
      `${SUPA_URL}/rest/v1/app_data?id=eq.1&select=veri`,
      { headers: { apikey: SUPA_KEY, Authorization: `Bearer ${SUPA_KEY}` } }
    );
    const rows = await res.json();
    return rows[0]?.veri || null;
  } catch { return null; }
}

async function supabaseVeriYaz(veri) {
  if (!SUPA_URL || !SUPA_KEY) return false;
  try {
    await fetch(`${SUPA_URL}/rest/v1/app_data?id=eq.1`, {
      method: "PATCH",
      headers: {
        apikey: SUPA_KEY,
        Authorization: `Bearer ${SUPA_KEY}`,
        "Content-Type": "application/json",
        Prefer: "return=minimal",
      },
      body: JSON.stringify({ veri }),
    });
    return true;
  } catch { return false; }
}

// eslint-disable-next-line no-unused-vars
const MOCK_SAKIN = { id:1, ad:"Can Öztürk", tel:"05362003040", siteId:1, siteIsmi:"Lale Apartmanı", blok:"A", daireNo:1, avatar:"CO", aidatBedeli:800, daireId:1 };
const MOCK_SITE  = { acilTel:"0532 111 22 33", yonetici:"Ahmet Yılmaz", isim:"Lale Apartmanı" };
const AYLAR = ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];
const ayLabel = (k) => { const [y,m]=k.split("-"); return `${AYLAR[parseInt(m)-1]} ${y}`; };

const INIT_STATE = {
  mesajlar: [],      // Boş — gerçek mesajlar Supabase'den/localStorage'dan gelir
  aidat: [],         // Boş — site kayıt tarihinden hesaplanır
  siteHarcamalar: [], // Boş — admin panelinden eklenir
  duyurular: [],     // Boş — admin panelinden eklenir
  arizalar: [],
  sikayet: [],       // Boş — kullanıcı kendisi ekler
};

// ============================================================
// ICONS
// ============================================================
const Icon = ({ name, size=20 }) => {
  const d = {
    chat:   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
    money:  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
    expense:<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>,
    flag:   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>,
    bell:   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
    wrench: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>,
    send:   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
    phone:  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.54 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.18 6.18l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
    check:  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>,
    clip:   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>,
  };
  return d[name] || null;
};

// ============================================================
// CSS — Global injection (her zaman yüklenir)
// ============================================================
const CSS = `
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
body{font-family:'Segoe UI',system-ui,sans-serif;background:#f1f5f9;color:#1e293b;}

/* LOGIN */
.sp-login{min-height:100vh;display:flex;align-items:center;justify-content:center;
  background:linear-gradient(135deg,#0f172a 0%,#1e3a5f 60%,#0f172a 100%);padding:20px;overflow:hidden;position:relative;}
.sp-login::before{content:'';position:absolute;top:-100px;right:-100px;width:350px;height:350px;border-radius:50%;
  background:radial-gradient(circle,rgba(59,130,246,0.15),transparent 70%);}
.sp-login::after{content:'';position:absolute;bottom:-80px;left:-80px;width:280px;height:280px;border-radius:50%;
  background:radial-gradient(circle,rgba(99,102,241,0.12),transparent 70%);}
.sp-card{position:relative;z-index:1;background:rgba(255,255,255,0.07);border:1px solid rgba(255,255,255,0.14);
  border-radius:24px;padding:36px 32px;width:100%;max-width:400px;}
.sp-logo{text-align:center;margin-bottom:28px;}
.sp-logo-ico{width:72px;height:72px;background:linear-gradient(135deg,#3b82f6,#6366f1);border-radius:20px;
  display:flex;align-items:center;justify-content:center;margin:0 auto 14px;font-size:32px;box-shadow:0 16px 40px rgba(59,130,246,0.35);}
.sp-logo h1{font-size:22px;font-weight:800;color:white;}
.sp-logo p{color:#64748b;font-size:13px;margin-top:4px;}
.sp-field{display:flex;flex-direction:column;gap:6px;margin-bottom:14px;}
.sp-field label{font-size:11px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:0.5px;}
.sp-field input{background:rgba(59,130,246,0.08);border:1.5px solid rgba(59,130,246,0.3);border-radius:12px;
  padding:13px 16px;color:#3b82f6;font-size:14px;outline:none;font-family:inherit;transition:border-color 0.2s;}
.sp-field input::placeholder{color:rgba(59,130,246,0.5);}
.sp-field input:focus{border-color:#3b82f6;}
.sp-field input::placeholder{color:#475569;}
.sp-btn{background:linear-gradient(135deg,#3b82f6,#6366f1);color:white;border:none;border-radius:12px;padding:14px;
  font-size:15px;font-weight:700;cursor:pointer;width:100%;margin-top:4px;min-height:50px;
  display:flex;align-items:center;justify-content:center;}
.sp-btn:hover{opacity:0.9;}.sp-btn:disabled{opacity:0.6;cursor:wait;}
.sp-err{background:rgba(239,68,68,0.15);border:1px solid rgba(239,68,68,0.25);color:#fca5a5;
  border-radius:10px;padding:10px 14px;font-size:13px;margin-bottom:12px;}
.sp-hint{text-align:center;font-size:12px;color:#3b82f6;font-weight:600;margin-top:16px;padding:10px;
  background:rgba(59,130,246,0.1);border-radius:10px;}

/* APP SHELL */
.sp-shell{display:flex;flex-direction:column;height:100vh;max-width:480px;margin:0 auto;
  background:white;box-shadow:0 0 40px rgba(0,0,0,0.12);}
.sp-top{background:white;border-bottom:1px solid #f1f5f9;padding:10px 14px;
  display:flex;align-items:center;gap:8px;flex-shrink:0;}
.sp-av{width:32px;height:32px;background:linear-gradient(135deg,#3b82f6,#6366f1);border-radius:10px;
  display:flex;align-items:center;justify-content:center;color:white;font-size:11px;font-weight:700;flex-shrink:0;}
.sp-name{font-size:14px;font-weight:700;color:#0f172a;}
.sp-site{font-size:11px;color:#64748b;}
.sp-acil{background:#fee2e2;color:#991b1b;border:none;border-radius:8px;padding:6px 10px;
  font-size:11px;font-weight:700;cursor:pointer;white-space:nowrap;animation:spa 2s infinite;flex-shrink:0;}
@keyframes spa{0%,100%{box-shadow:0 0 0 0 rgba(239,68,68,0.3);}50%{box-shadow:0 0 0 6px rgba(239,68,68,0);}}
.sp-logout{width:30px;height:30px;background:rgba(239,68,68,0.1);border:none;border-radius:8px;
  cursor:pointer;font-size:13px;color:#ef4444;flex-shrink:0;display:flex;align-items:center;justify-content:center;}
.sp-lang{display:flex;gap:3px;}
.sp-lb{padding:3px 7px;border-radius:5px;border:1px solid #e2e8f0;background:white;cursor:pointer;
  font-size:10px;font-weight:700;color:#64748b;}
.sp-lb.on{background:#0f172a;color:white;border-color:#0f172a;}

/* SAYFA */
.sp-page{flex:1;overflow:hidden;display:flex;flex-direction:column;}
.sp-panel{flex:1;overflow-y:auto;padding:16px;}
.sp-ptitle{font-size:18px;font-weight:800;color:#0f172a;margin-bottom:2px;}
.sp-psub{font-size:12px;color:#64748b;margin-bottom:14px;}

/* CHAT */
.sp-chat{display:flex;flex-direction:column;height:100%;}
.sp-chdr{padding:10px 14px;background:#f8fafc;border-bottom:1px solid #e2e8f0;
  display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}
.sp-chname{font-size:13px;font-weight:700;color:#0f172a;}
.sp-chsub{font-size:11px;color:#64748b;}
.sp-cbadge{font-size:10px;background:#ede9fe;color:#533489;padding:3px 8px;border-radius:20px;font-weight:600;}
.sp-msgs{flex:1;overflow-y:auto;padding:12px;display:flex;flex-direction:column;gap:4px;background:#f8fafc;}
.sp-div{text-align:center;margin:8px 0;}
.sp-div span{background:#e2e8f0;color:#64748b;font-size:10px;font-weight:600;padding:3px 10px;border-radius:20px;}
.sp-brow{display:flex;gap:6px;align-items:flex-end;margin-bottom:2px;}
.sp-brow.mine{flex-direction:row-reverse;}
.sp-av2{width:26px;height:26px;border-radius:50%;background:#e2e8f0;color:#64748b;
  display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;flex-shrink:0;}
.sp-av2.ynt{background:#3b82f6;color:white;}
.sp-bub{max-width:85%;border-radius:16px;padding:8px 12px;}
.mine .sp-bub{background:#3b82f6;color:white;border-bottom-right-radius:3px;}
.theirs .sp-bub{background:white;color:#1e293b;border-bottom-left-radius:3px;border:1px solid #e2e8f0;}
.ynt-bub{background:#1e293b;color:white;border-bottom-left-radius:3px;}
.sp-bname{font-size:10px;font-weight:700;opacity:0.7;margin-bottom:2px;}
.sp-btext{font-size:13px;line-height:1.55;word-break:break-word;white-space:pre-wrap;}
.sp-btime{font-size:9px;opacity:0.6;margin-top:3px;text-align:right;}
.sp-cinp{padding:10px 12px;background:white;border-top:1px solid #f1f5f9;
  display:flex;gap:8px;align-items:center;flex-shrink:0;}
.sp-cinp input{flex:1;background:#f1f5f9;border:none;border-radius:20px;padding:9px 14px;
  font-size:13px;outline:none;font-family:inherit;}
.sp-send{width:38px;height:38px;background:#3b82f6;color:white;border:none;border-radius:50%;
  cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
.sp-send:disabled{opacity:0.4;}
.sp-att{width:36px;height:36px;background:#f1f5f9;border:none;border-radius:50%;
  cursor:pointer;font-size:16px;flex-shrink:0;}
.sp-file-bub{display:flex;align-items:center;gap:8px;background:rgba(0,0,0,0.12);
  border-radius:10px;padding:8px 10px;cursor:pointer;margin-bottom:2px;}

/* AİDAT */
.sp-og{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:14px;}
.sp-ok{border-radius:10px;padding:10px;text-align:center;}
.sp-okn{font-size:18px;font-weight:800;color:#0f172a;}
.sp-okl{font-size:10px;color:#64748b;margin-top:1px;}
.sp-alist{display:flex;flex-direction:column;gap:8px;}
.sp-arow{background:white;border-radius:12px;padding:10px 12px;border:1px solid #f1f5f9;
  display:flex;justify-content:space-between;align-items:center;gap:10px;}
.sp-aico{width:30px;height:30px;border-radius:8px;display:flex;align-items:center;justify-content:center;
  font-size:14px;font-weight:700;flex-shrink:0;}
.sp-aay{font-size:13px;font-weight:600;color:#1e293b;}
.sp-atarih{font-size:11px;color:#94a3b8;margin-top:1px;}
.sp-atutar{font-size:14px;font-weight:800;}
.sp-abdg{font-size:10px;font-weight:600;padding:2px 8px;border-radius:20px;display:inline-block;margin-top:2px;}

/* HARCAMA */
.sp-htop{background:#1e293b;border-radius:12px;padding:16px;color:white;margin-bottom:12px;text-align:center;}
.sp-hlist{display:flex;flex-direction:column;gap:6px;}
.sp-hrow{background:white;border-radius:10px;padding:10px 12px;border:1px solid #f1f5f9;
  display:flex;align-items:center;gap:10px;}
.sp-hico{width:36px;height:36px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;}
.sp-hac{font-size:13px;font-weight:600;color:#1e293b;}
.sp-hdt{font-size:11px;color:#94a3b8;margin-top:1px;}
.sp-hamt{font-size:14px;font-weight:800;color:#0f172a;margin-left:auto;flex-shrink:0;}
.sp-kat{display:flex;gap:5px;flex-wrap:wrap;margin-bottom:10px;}
.sp-kb{padding:4px 10px;border-radius:20px;border:1px solid #e2e8f0;background:white;cursor:pointer;font-size:11px;font-weight:600;color:#64748b;}
.sp-kb.on{background:#1e293b;color:white;border-color:#1e293b;}

/* DUYURULAR */
.sp-dkart{background:white;border-radius:12px;border:1px solid #e2e8f0;overflow:hidden;margin-bottom:10px;}
.sp-dhdr{display:flex;justify-content:space-between;align-items:flex-start;padding:12px 14px;cursor:pointer;}
.sp-dbaslik{font-size:14px;font-weight:700;color:#1e293b;}
.sp-dtarih{font-size:11px;color:#94a3b8;margin-top:2px;}
.sp-dbody{padding:0 14px 14px;border-top:1px solid #f1f5f9;}
.sp-dbody p{font-size:13px;color:#475569;line-height:1.6;padding-top:10px;}
.sp-ddosya{display:flex;align-items:center;gap:8px;margin-top:10px;background:#f0f7ff;border-radius:10px;padding:10px 12px;flex-wrap:wrap;}

/* ŞİKAYET / ARIZA */
.sp-stabs{display:flex;gap:6px;margin-bottom:12px;}
.sp-stab{flex:1;padding:8px;border-radius:10px;border:1px solid #e2e8f0;background:white;cursor:pointer;font-size:12px;font-weight:600;color:#64748b;}
.sp-stab.on{background:#0f172a;color:white;border-color:#0f172a;}
.sp-skart{background:white;border-radius:12px;padding:12px;border:1px solid #f1f5f9;margin-bottom:8px;}
.sp-skh{display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;}
.sp-stur{font-size:11px;font-weight:600;padding:2px 8px;border-radius:20px;}
.sp-sdur{font-size:11px;font-weight:600;padding:2px 8px;border-radius:20px;}
.sp-sbas{font-size:13px;font-weight:600;color:#1e293b;margin-bottom:4px;}
.sp-sice{font-size:12px;color:#64748b;line-height:1.5;margin-bottom:6px;}
.sp-salt{display:flex;justify-content:space-between;font-size:10px;color:#94a3b8;}
.sp-sf{display:flex;flex-direction:column;gap:5px;margin-bottom:12px;}
.sp-sf label{font-size:12px;font-weight:600;color:#374151;}
.sp-sf input,.sp-sf textarea{border:1px solid #e2e8f0;border-radius:10px;padding:9px 12px;font-size:13px;outline:none;font-family:inherit;resize:vertical;}
.sp-sf input:focus,.sp-sf textarea:focus{border-color:#3b82f6;}
.sp-sturb{flex:1;padding:8px;border-radius:10px;border:1px solid #e2e8f0;background:white;cursor:pointer;font-size:11px;font-weight:600;color:#64748b;}
.sp-gsend{background:linear-gradient(135deg,#3b82f6,#6366f1);color:white;border:none;border-radius:10px;padding:12px;font-size:13px;font-weight:700;cursor:pointer;width:100%;}
.sp-gsend:disabled{opacity:0.5;cursor:default;}

/* ACİL */
.sp-aov{position:fixed;inset:0;background:rgba(0,0,0,0.6);display:flex;align-items:flex-end;justify-content:center;z-index:200;}
.sp-abox{background:white;border-radius:20px 20px 0 0;width:100%;max-width:480px;padding:24px;text-align:center;}
.sp-atel{display:flex;align-items:center;justify-content:center;gap:8px;background:#ef4444;color:white;
  border-radius:12px;padding:14px;font-size:18px;font-weight:700;text-decoration:none;margin-bottom:12px;width:100%;}
.sp-agrid{display:grid;grid-template-columns:1fr 1fr;gap:6px;margin-bottom:12px;}
.sp-aitem{background:#f8fafc;border-radius:8px;padding:6px 10px;font-size:11px;color:#475569;text-align:left;}
.sp-akapat{background:#f1f5f9;border:none;border-radius:10px;padding:10px;width:100%;font-size:13px;font-weight:600;cursor:pointer;color:#64748b;}

/* BOTTOM NAV */
.sp-nav{display:flex;background:white;border-top:1px solid #f1f5f9;flex-shrink:0;}
.sp-nb{flex:1;display:flex;flex-direction:column;align-items:center;gap:2px;padding:7px 2px;
  border:none;background:none;cursor:pointer;color:#94a3b8;font-size:8px;font-weight:600;}
.sp-nb.on{color:#3b82f6;}
.sp-nb svg{width:20px;height:20px;stroke:currentColor;fill:none;stroke-width:2;}

 @media(max-width:480px){
  .sp-shell{max-width:100%;height:100dvh;border-radius:0;}
  .sp-panel{padding:10px 12px;}
  .sp-ptitle{font-size:15px;}
  .sp-psub{font-size:11px;}
  .sp-og{grid-template-columns:1fr 1fr;}
  .sp-arow{flex-wrap:wrap;gap:6px;}
  .sp-htop{padding:10px 12px;}
  .sp-kat{gap:4px;flex-wrap:wrap;}
  .sp-kb{font-size:10px;padding:3px 8px;}
  .sp-msgs{padding:8px;}
  .sp-cinp{padding:7px 10px;gap:6px;}
  .sp-chdr{padding:8px 10px;flex-wrap:wrap;gap:4px;}
  .sp-bub{max-width:88%;}
  .sp-top{flex-wrap:nowrap;gap:4px;padding:7px 10px;}
  .sp-nav{padding-bottom:env(safe-area-inset-bottom);}
  .sp-nb{font-size:7px;padding:5px 1px;}
  .sp-nb svg{width:19px;height:19px;}
  .sp-abox{padding:16px;border-radius:16px 16px 0 0;}
  .sp-agrid{grid-template-columns:1fr 1fr;gap:5px;}
  .sp-stabs{flex-wrap:wrap;gap:5px;}
  .sp-stab{font-size:11px;padding:6px 10px;}
  .sp-dhdr{padding:10px 12px;}
  .sp-dbody{padding:0 12px 12px;}
  .sp-alist{gap:6px;}
  .sp-sf input,.sp-sf textarea{font-size:13px;padding:8px 10px;}
  .sp-gsend{padding:11px;font-size:13px;}
  .sp-card{padding:12px;}
}
@media(max-width:360px){
  .sp-nb{font-size:6px;}
  .sp-ptitle{font-size:14px;}
  .sp-og{grid-template-columns:1fr 1fr;}
  .sp-top .sp-lang{display:none;}
}

`;

// CSS'i head'e enjekte et
if (typeof document !== "undefined") {
  const id = "sakin-panel-css";
  if (!document.getElementById(id)) {
    const s = document.createElement("style");
    s.id = id; s.textContent = CSS;
    document.head.appendChild(s);
  }
}

// ============================================================
// LOGIN EKRANI
// ============================================================
function LoginScreen({ onLogin, t }) {
  const [tel, setTel]     = useState("");
  const [sifre, setSifre] = useState("");
  const [err, setErr]     = useState("");
  const [loading, setLoading] = useState(false);

  const giris = async () => {
    if (!tel.trim() || !sifre.trim()) { setErr("Telefon ve şifre gereklidir."); return; }
    setLoading(true); setErr("");
    try {
      // Tüm veri Supabase app_data'dan gelir
      const appData = await supabaseVeriCek();
      if (!appData) { setErr("Sunucuya bağlanılamadı. İnternet bağlantınızı kontrol edin."); setLoading(false); return; }
      const norm = tel.replace(/[\s\-\(\)]/g,"");

      // sakinKullanicilari içinde ara
      const sakinler = appData.sakinKullanicilari || [];
      const siteler  = appData.siteler || [];
      const detaylar = appData.siteDetay || [];

      // Telefon eşleşmesi — tüm boşluk ve tire karakterlerini temizle
      const temizle = (s) => String(s||"").replace(/[\s\-\(\)]/g,"");
      const user = sakinler.find(u =>
        temizle(u.tel) === temizle(norm) &&
        String(u.sifre) === String(sifre) &&
        u.aktif !== false
      );

      if (!user) {
        // Hata ayıklama: telefon listesi konsola yaz
        console.log("Kayıtlı telefonlar:", sakinler.map(u => temizle(u.tel)));
        console.log("Girilen telefon:", temizle(norm));
        setErr("Telefon numarası veya şifre hatalı."); setLoading(false); return;
      }
      if (user.rol === "siteYoneticisi") { setErr("Site yöneticileri admin panelini kullanın."); setLoading(false); return; }

      const site  = siteler.find(s => s.id === user.siteId);
      const daire = user.daireId ? detaylar.find(dd => dd.id === user.daireId) : null;

      onLogin({
        id: user.id,
        ad: user.ad,
        tel: user.tel,
        siteId: user.siteId,
        siteIsmi: site?.siteIsmi || "Bilinmiyor",
        blok: daire?.blok || "—",
        daireNo: daire?.daireNo || "—",
        avatar: user.ad.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase(),
        aidatBedeli: daire?.aidatBedeli || site?.aidatBedeli || 0,
        daireId: user.daireId || null,
      }, appData);
      return;

    } catch(e) {
      setErr("Bağlantı hatası. Lütfen tekrar deneyin.");
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sp-login">
      <div className="sp-card">
        <div className="sp-logo">
          <div className="sp-logo-ico">🏢</div>
          <h1>{t.appName}</h1>
          <p>Sakin Portalı</p>
        </div>
        {err && <div className="sp-err">⚠️ {err}</div>}
        <div className="sp-field">
          <label>{t.phone}</label>
          <input value={tel} onChange={e=>setTel(e.target.value)} placeholder="05xx xxx xx xx" autoComplete="username"/>
        </div>
        <div className="sp-field">
          <label>{t.password}</label>
          <input type="password" value={sifre} onChange={e=>setSifre(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&giris()} placeholder="••••••••" autoComplete="current-password"/>
        </div>
        <button className="sp-btn" onClick={giris} disabled={loading}>
          {loading ? "Kontrol ediliyor..." : t.login}
        </button>
        <div className="sp-hint">Şifrenizi unutursanız yöneticinizle iletişime geçin.</div>
      </div>
    </div>
  );
}

// ============================================================
// MESAJLAŞMA — Tarih + Dosya paylaşımı
// ============================================================
function Mesajlasma({ sakin, state, setState, t, adminData }) {
  const [input, setInput] = useState("");
  const [onizleme, setOnizleme] = useState(null); // { tip, url, ad }
  const [linkDetect, setLinkDetect] = useState("");
  const altRef  = useRef(null);
  const fileRef = useRef(null);

  useEffect(() => { altRef.current?.scrollIntoView({ behavior:"smooth" }); }, [state.mesajlar]);

  const saatStr = (ts) => { const d=new Date(ts); return `${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`; };
  const gunLabel = (ts) => {
    const d=new Date(ts), b=new Date(), dd=new Date();
    dd.setDate(dd.getDate()-1);
    if(d.toDateString()===b.toDateString()) return "Bugün";
    if(d.toDateString()===dd.toDateString()) return "Dün";
    return d.toLocaleDateString("tr-TR",{day:"numeric",month:"long",year:"numeric"});
  };
  const boyutStr = (b) => b<1048576?`${(b/1024).toFixed(0)} KB`:`${(b/1048576).toFixed(1)} MB`;

  // Link tespiti
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const linklerBul = (metin) => metin.match(urlRegex) || [];
  const youtubeId = (url) => {
    const m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})/);
    return m ? m[1] : null;
  };

  // Dosya ikonu
  const dosyaIco = (tur="") => {
    if(tur.includes("pdf")) return "📄";
    if(tur.includes("word")||tur.includes("doc")) return "📝";
    if(tur.includes("sheet")||tur.includes("excel")||tur.includes("xls")) return "📊";
    if(tur.includes("zip")||tur.includes("rar")) return "🗜️";
    return "📎";
  };

  // Mesaj engeli
  const mesajEngelli = () => {
    try { const ben=(adminData?.sakinKullanicilari||[]).find(u=>u.id===sakin.id); return ben?.mesajEngel===true; } catch { return false; }
  };

  // Mesajı Supabase'e yaz — upsert kullan (Realtime tetikler, admin görür)
  const mesajSupabaseYaz = async (yeniMesajlar) => {
    const chatKey = `siteMesajlar_${sakin.siteId}`;
    if (!SUPA_URL || !SUPA_KEY) return;
    try {
      // Mevcut veriyi al
      const res = await fetch(`${SUPA_URL}/rest/v1/app_data?id=eq.1&select=veri`,
        { headers: { apikey: SUPA_KEY, Authorization: `Bearer ${SUPA_KEY}` } });
      const rows = await res.json();
      const mevcutVeri = rows[0]?.veri || {};
      const yeniVeri = { ...mevcutVeri, [chatKey]: yeniMesajlar };
      // UPSERT kullan — Realtime'ı tetikler, admin paneli anında güncellenir
      await fetch(`${SUPA_URL}/rest/v1/app_data`, {
        method: "POST",
        headers: {
          apikey: SUPA_KEY, Authorization: `Bearer ${SUPA_KEY}`,
          "Content-Type": "application/json",
          Prefer: "resolution=merge-duplicates,return=minimal"
        },
        body: JSON.stringify({ id: 1, veri: yeniVeri }),
      });
    } catch(e) { console.error("Mesaj yazma hatası:", e); }
  };

  // Resim sıkıştır (max 1200px, kalite 0.85)
  const resimSikistir = (file) => new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const MAX = 1200;
      let w=img.width, h=img.height;
      if(w>MAX||h>MAX) { if(w>h){h=Math.round(h*MAX/w);w=MAX;}else{w=Math.round(w*MAX/h);h=MAX;} }
      const canvas=document.createElement("canvas"); canvas.width=w; canvas.height=h;
      canvas.getContext("2d").drawImage(img,0,0,w,h);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL("image/jpeg",0.85));
    };
    img.onerror=()=>{URL.revokeObjectURL(url);resolve(null);};
    img.src=url;
  });

  // Mesaj gönder (metin + link algılama)
  const gonder = () => {
    if(mesajEngelli()) return;
    const tmz=input.trim(); if(!tmz) return;
    const linkler=linklerBul(tmz);
    const yeniMsg={
      id:Date.now(),kId:sakin.id,kAd:sakin.ad,kAv:sakin.avatar,
      tarih:new Date().toISOString(),mesaj:tmz,tip:"metin",
      linkler: linkler.length>0 ? linkler : undefined,
    };
    setState(s=>{
      const ym=[...s.mesajlar,yeniMsg];
      mesajSupabaseYaz(ym);
      return {...s,mesajlar:ym};
    });
    setInput(""); setLinkDetect("");
  };

  // Dosya gönder — resim/video/belge tam base64 kaydedilir
  const dosyaGonder = async (e) => {
    const file=e.target.files?.[0]; if(!file) return;
    if(mesajEngelli()){e.target.value="";return;}
    const tip=file.type.startsWith("image/")?"resim":file.type.startsWith("video/")?"video":"dosya";
    const MAX=8*1024*1024; // 8MB limit

    const kaydet=(dosyaData)=>{
      const yeniMsg={
        id:Date.now(),kId:sakin.id,kAd:sakin.ad,kAv:sakin.avatar,
        tarih:new Date().toISOString(),mesaj:file.name,tip,
        dosyaAdi:file.name,dosyaBoyut:file.size,dosyaTur:file.type,
        dosyaData, // TÜM verileri sakla — önizleme için
        buyukDosya:!dosyaData,
      };
      setState(s=>{
        const ym=[...s.mesajlar,yeniMsg];
        mesajSupabaseYaz(ym);
        return {...s,mesajlar:ym};
      });
    };

    if(tip==="resim") {
      const s=await resimSikistir(file);
      kaydet(s);
    } else if(file.size<=MAX) {
      const reader=new FileReader();
      reader.onload=(ev)=>kaydet(ev.target.result);
      reader.readAsDataURL(file);
    } else {
      kaydet(null); // çok büyük — meta only
    }
    e.target.value="";
  };

  // Tarih gruplu mesaj listesi
  let sonGun=""; const gruplu=[];
  state.mesajlar.forEach(m=>{
    const gun=new Date(m.tarih).toDateString();
    if(gun!==sonGun){gruplu.push({tip:"ayrac",label:gunLabel(m.tarih),key:gun});sonGun=gun;}
    gruplu.push({tip:"mesaj",...m});
  });

  // Supabase periyodik sync
  useEffect(()=>{
    if(!sakin) return;
    const SUPA_URL=process.env.REACT_APP_SUPABASE_URL;
    const SUPA_KEY=process.env.REACT_APP_SUPABASE_ANON_KEY;
    const chatKey=`siteMesajlar_${sakin.siteId}`;
    const k=setInterval(async()=>{
      try {
        if(!SUPA_URL||!SUPA_KEY) return;
        const res=await fetch(`${SUPA_URL}/rest/v1/app_data?id=eq.1&select=veri`,{headers:{apikey:SUPA_KEY,Authorization:`Bearer ${SUPA_KEY}`}});
        const rows=await res.json();
        const mesajlar=rows[0]?.veri?.[chatKey];
        if(Array.isArray(mesajlar)) setState(prev=>{
          if(JSON.stringify(prev.mesajlar)===JSON.stringify(mesajlar)) return prev;
          return {...prev,mesajlar};
        });
      } catch{}
    },5000);
    return ()=>clearInterval(k);
  },[sakin]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── MESAJ RENDER YARDIMCILARI ────────────────────────────────
  const LinkOnizleme = ({url}) => {
    const ytId=youtubeId(url);
    if(ytId) return (
      <div style={{marginTop:6,borderRadius:10,overflow:"hidden",border:"1px solid rgba(255,255,255,0.15)"}}>
        <iframe
          src={`https://www.youtube.com/embed/${ytId}`}
          style={{width:"100%",height:180,border:"none",display:"block"}}
          allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture"
          allowFullScreen title="YouTube"/>
        <a href={url} target="_blank" rel="noopener noreferrer"
          style={{display:"block",padding:"6px 10px",background:"rgba(0,0,0,0.3)",fontSize:10,color:"#60a5fa",textDecoration:"none",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
          🔗 {url}
        </a>
      </div>
    );
    return (
      <a href={url} target="_blank" rel="noopener noreferrer"
        style={{display:"flex",alignItems:"center",gap:6,marginTop:4,padding:"6px 10px",background:"rgba(0,0,0,0.15)",borderRadius:8,textDecoration:"none",fontSize:11,color:"#93c5fd",wordBreak:"break-all"}}>
        🔗 {url}
      </a>
    );
  };

  const ResimMesaj = ({item,mine})=>(
    <div style={{marginBottom:4}}>
      {item.dosyaData ? (
        <img src={item.dosyaData} alt={item.dosyaAdi}
          style={{maxWidth:"100%",maxHeight:240,borderRadius:10,display:"block",cursor:"pointer",objectFit:"cover"}}
          onClick={()=>setOnizleme({tip:"resim",url:item.dosyaData,ad:item.dosyaAdi})}/>
      ) : (
        <div style={{background:"rgba(0,0,0,0.2)",borderRadius:8,padding:"8px 12px",fontSize:12,opacity:0.7}}>🖼️ {item.dosyaAdi} (önizleme yok)</div>
      )}
      {item.dosyaAdi && <div style={{fontSize:10,opacity:0.6,marginTop:2}}>{item.dosyaAdi}{item.dosyaBoyut?` · ${boyutStr(item.dosyaBoyut)}`:""}</div>}
    </div>
  );

  const VideoMesaj = ({item})=>(
    <div style={{marginBottom:4,borderRadius:10,overflow:"hidden",border:"1px solid rgba(255,255,255,0.15)"}}>
      {item.dosyaData ? (
        <video controls style={{width:"100%",maxHeight:220,display:"block",borderRadius:10}} src={item.dosyaData}/>
      ) : (
        <div style={{background:"rgba(0,0,0,0.2)",borderRadius:8,padding:"10px 14px",display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:24}}>🎬</span>
          <div><div style={{fontSize:12,fontWeight:600}}>{item.dosyaAdi}</div><div style={{fontSize:10,opacity:0.7}}>{item.dosyaBoyut?boyutStr(item.dosyaBoyut):""} · Önizleme yok</div></div>
        </div>
      )}
    </div>
  );

  const DosyaMesaj = ({item})=>(
    <div style={{display:"flex",alignItems:"center",gap:10,background:"rgba(0,0,0,0.15)",borderRadius:10,padding:"10px 14px",cursor:item.dosyaData?"pointer":"default",marginBottom:4}}
      onClick={()=>{ if(item.dosyaData) setOnizleme({tip:"dosya",url:item.dosyaData,ad:item.dosyaAdi,tur:item.dosyaTur}); }}>
      <span style={{fontSize:26,flexShrink:0}}>{dosyaIco(item.dosyaTur||"")}</span>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:12,fontWeight:700,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item.dosyaAdi}</div>
        <div style={{fontSize:10,opacity:0.7}}>{item.dosyaBoyut?boyutStr(item.dosyaBoyut):""} · {item.dosyaData?"Tıkla → Önizle/İndir":"Büyük dosya"}</div>
      </div>
      {item.dosyaData && <span style={{fontSize:18,flexShrink:0}}>👁️</span>}
    </div>
  );

  const MetinMesaj = ({item,mine,ynt})=>{
    const linkler=item.linkler||linklerBul(item.mesaj||"");
    const parca=item.mesaj.split(urlRegex).filter(Boolean);
    return (
      <div>
        <div className="sp-btext" style={{wordBreak:"break-word"}}>
          {parca.map((p,i)=>
            urlRegex.test(p)
              ? <a key={i} href={p} target="_blank" rel="noopener noreferrer"
                  style={{color:mine||ynt?"#bfdbfe":"#2563eb",textDecoration:"underline"}}>{p}</a>
              : <span key={i}>{p}</span>
          )}
        </div>
        {linkler.map((url,i)=><LinkOnizleme key={i} url={url}/>)}
      </div>
    );
  };

  return (<>
    <div className="sp-chat">
      <div className="sp-chdr">
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <div style={{fontSize:22}}>🏢</div>
          <div><div className="sp-chname">{sakin.siteIsmi} — Genel</div><div className="sp-chsub">{t.allResidents}</div></div>
        </div>
        <div className="sp-cbadge">{t.groupChat}</div>
      </div>

      <div className="sp-msgs">
        {gruplu.map(item=>{
          if(item.tip==="ayrac") return <div key={item.key} className="sp-div"><span>{item.label}</span></div>;
          const mine=item.kId===sakin.id, ynt=item.kId===99;
          return (
            <div key={item.id} className={`sp-brow ${mine?"mine":"theirs"}`}>
              {!mine && <div className={`sp-av2 ${ynt?"ynt":""}`}>{item.kAv}</div>}
              <div style={{maxWidth:"88%"}}>
                {!mine && <div className="sp-bname" style={{marginBottom:2}}>{item.kAd}</div>}
                <div className={`sp-bub ${ynt?"ynt-bub":""}`} style={{padding:item.tip==="resim"||item.tip==="video"?"6px":"8px 12px"}}>
                  {item.tip==="resim" && <ResimMesaj item={item} mine={mine}/>}
                  {item.tip==="video" && <VideoMesaj item={item}/>}
                  {item.tip==="dosya" && <DosyaMesaj item={item}/>}
                  {(!item.tip||item.tip==="metin") && <MetinMesaj item={item} mine={mine} ynt={ynt}/>}
                  <div className="sp-btime">{saatStr(item.tarih)}</div>
                </div>
              </div>
            </div>
          );
        })}
        <div ref={altRef}/>
      </div>

      {/* GİRİŞ ALANI */}
      <div className="sp-cinp">
        <input ref={fileRef} type="file" accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar" onChange={dosyaGonder} style={{display:"none"}}/>
        {mesajEngelli() ? (
          <div style={{flex:1,padding:"10px 14px",background:"#fee2e2",borderRadius:12,fontSize:12,color:"#991b1b",fontWeight:600,textAlign:"center"}}>
            🚫 Mesaj gönderme yetkiniz kaldırılmıştır.
          </div>
        ) : (
          <>
            <button className="sp-att" onClick={()=>fileRef.current?.click()} title="Dosya/Fotoğraf/Video">📎</button>
            <input placeholder={t.typeMsg} value={input}
              onChange={e=>{setInput(e.target.value); const l=linklerBul(e.target.value); setLinkDetect(l[0]||"");}}
              onKeyDown={e=>e.key==="Enter"&&!e.shiftKey&&gonder()}
              style={{flex:1,background:"#f1f5f9",border:"none",borderRadius:20,padding:"9px 14px",fontSize:13,outline:"none",fontFamily:"inherit"}}/>
            <button className="sp-send" onClick={gonder} disabled={!input.trim()}><Icon name="send" size={16}/></button>
          </>
        )}
      </div>
      {linkDetect && (
        <div style={{padding:"4px 14px 6px",fontSize:11,color:"#3b82f6",background:"#eff6ff"}}>
          🔗 Link algılandı — gönderilince önizleme gösterilir
        </div>
      )}

      {/* ÖNİZLEME MODAL */}
      {onizleme && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.9)",zIndex:500,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}
          onClick={()=>setOnizleme(null)}>
          <div style={{position:"absolute",top:16,right:16,display:"flex",gap:8}}>
            <a href={onizleme.url} download={onizleme.ad}
              onClick={e=>e.stopPropagation()}
              style={{background:"#3b82f6",color:"white",padding:"8px 16px",borderRadius:10,fontSize:13,fontWeight:700,textDecoration:"none"}}>
              ⬇️ İndir
            </a>
            {onizleme.tip==="dosya" && (
              <a href={onizleme.url} target="_blank" rel="noopener noreferrer"
                onClick={e=>e.stopPropagation()}
                style={{background:"#10b981",color:"white",padding:"8px 16px",borderRadius:10,fontSize:13,fontWeight:700,textDecoration:"none"}}>
                👁️ Aç
              </a>
            )}
            <button onClick={()=>setOnizleme(null)}
              style={{background:"rgba(255,255,255,0.15)",color:"white",border:"none",borderRadius:10,padding:"8px 14px",cursor:"pointer",fontSize:18}}>
              ✕
            </button>
          </div>
          <div style={{maxWidth:"90vw",maxHeight:"85vh",display:"flex",flexDirection:"column",alignItems:"center",gap:8}}
            onClick={e=>e.stopPropagation()}>
            {onizleme.tip==="resim" && (
              <img src={onizleme.url} alt={onizleme.ad}
                style={{maxWidth:"90vw",maxHeight:"78vh",borderRadius:12,objectFit:"contain"}}/>
            )}
            {onizleme.tip==="video" && (
              <video controls autoPlay style={{maxWidth:"90vw",maxHeight:"78vh",borderRadius:12}} src={onizleme.url}/>
            )}
            {onizleme.tip==="dosya" && (
              <div style={{background:"white",borderRadius:16,padding:"32px 48px",textAlign:"center"}}>
                <div style={{fontSize:64,marginBottom:12}}>{dosyaIco(onizleme.tur||"")}</div>
                <div style={{fontSize:16,fontWeight:700,color:"#0f172a",marginBottom:8}}>{onizleme.ad}</div>
                {onizleme.tur?.includes("pdf") ? (
                  <iframe src={onizleme.url} style={{width:"70vw",height:"60vh",border:"none",borderRadius:8,marginTop:8}} title={onizleme.ad}/>
                ) : (
                  <div style={{fontSize:13,color:"#64748b",marginTop:8}}>İndirmek için yukarıdaki butonu kullanın</div>
                )}
              </div>
            )}
            <div style={{color:"rgba(255,255,255,0.6)",fontSize:12}}>{onizleme.ad}</div>
          </div>
        </div>
      )}
    </div>
  </>
  );
}


// ============================================================
// PROFİL DÜZENLE — Admin veritabanına yazar
// ============================================================
function ProfilDuzenle({ sakin, setSakin, adminData, setAdminData, t }) {
  const [form, setForm] = useState({ ad: sakin.ad, tel: sakin.tel, sifre: "" });
  const [kaydedildi, setKaydedildi] = useState(false);
  const [err, setErr] = useState("");

  const kaydet = async () => {
    setErr("");
    if (!form.ad.trim()) { setErr("Ad soyad boş olamaz."); return; }
    if (!form.tel.trim()) { setErr("Telefon boş olamaz."); return; }

    // Supabase'e yaz
    try {
      const mevcutData = await supabaseVeriCek();
      if (mevcutData?.sakinKullanicilari) {
        const guncellenmis = mevcutData.sakinKullanicilari.map(u => {
          if (u.id === sakin.id) {
            return {
              ...u,
              ad: form.ad,
              tel: form.tel.replace(/[\s\-\(\)]/g,""),
              ...(form.sifre ? { sifre: form.sifre } : {}),
            };
          }
          return u;
        });
        await supabaseVeriYaz({ ...mevcutData, sakinKullanicilari: guncellenmis });
      }
    } catch(e) { console.error("Profil güncelleme hatası:", e); }

    // Sakin state'ini güncelle
    setSakin(p => ({
      ...p,
      ad: form.ad,
      tel: form.tel.replace(/[\s\-\(\)]/g,""),
      avatar: form.ad.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase(),
    }));

    setKaydedildi(true);
    setForm(p => ({ ...p, sifre: "" }));
    setTimeout(() => setKaydedildi(false), 3000);
  };

  return (
    <div className="sp-panel">
      <div className="sp-ptitle">Profilim</div>
      <div className="sp-psub">Bilgilerinizi güncelleyin</div>

      {/* Avatar */}
      <div style={{ textAlign:"center", marginBottom:20 }}>
        <div style={{ width:72, height:72, background:"linear-gradient(135deg,#3b82f6,#6366f1)", borderRadius:"50%",
          display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:24, fontWeight:800, margin:"0 auto 10px" }}>
          {sakin.avatar}
        </div>
        <div style={{fontWeight:700,fontSize:15,color:"#0f172a"}}>{sakin.ad}</div>
        <div style={{fontSize:12,color:"#64748b"}}>{sakin.siteIsmi} · {sakin.blok} Blok Daire {sakin.daireNo}</div>
      </div>

      <div style={{ background:"white", borderRadius:14, padding:20, border:"1px solid #e2e8f0" }}>
        {err && <div style={{background:"#fee2e2",color:"#991b1b",padding:"10px 14px",borderRadius:10,fontSize:13,marginBottom:14}}>⚠️ {err}</div>}
        {kaydedildi && <div style={{background:"#d1fae5",color:"#065f46",padding:"10px 14px",borderRadius:10,fontSize:13,fontWeight:600,marginBottom:14}}>✅ Bilgileriniz başarıyla güncellendi!</div>}

        <div className="sp-sf">
          <label>Ad Soyad</label>
          <input value={form.ad} onChange={e=>setForm(p=>({...p,ad:e.target.value}))} placeholder="Ad Soyad"/>
        </div>
        <div className="sp-sf">
          <label>Telefon (Kullanıcı Adı)</label>
          <input value={form.tel} onChange={e=>setForm(p=>({...p,tel:e.target.value}))} placeholder="05xx xxx xx xx"/>
        </div>
        <div className="sp-sf">
          <label>Yeni Şifre <span style={{color:"#94a3b8",fontWeight:400}}>(değiştirmeyecekseniz boş bırakın)</span></label>
          <input type="password" value={form.sifre} onChange={e=>setForm(p=>({...p,sifre:e.target.value}))} placeholder="••••••••"/>
        </div>

        <div style={{background:"#f0f7ff",borderRadius:8,padding:"10px 14px",marginBottom:14,fontSize:12,color:"#1e40af"}}>
          💡 Telefon numaranız kullanıcı adınızdır. Değiştirirseniz bir sonraki girişte yeni numaranızı kullanın.
        </div>

        <button className="sp-gsend" onClick={kaydet}>💾 Değişiklikleri Kaydet</button>
      </div>
    </div>
  );
}

// ============================================================
// AİDAT TAKİBİ — Toplam borç banner'ı + Online Ödeme
// ============================================================
function AidatTakibi({ sakin, state, setState, t, adminData }) {
  const aylar = state.aidat;
  const [odemeModal, setOdemeModal] = useState(false);
  const [secilenAy, setSecilenAy] = useState(null);
  const [odemeAdim, setOdemeAdim] = useState(1); // 1=özet, 2=onay bekle, 3=başarı

  const odendi   = aylar.filter(a=>a.durum==="odendi").length;
  const gecikti  = aylar.filter(a=>a.durum==="gecikti").length;
  const bekliyor = aylar.filter(a=>a.durum==="bekliyor").length;
  const toplamOdenen = aylar.filter(a=>a.durum==="odendi").reduce((s,a)=>s+a.tutar,0);
  const gecBorc = aylar.filter(a=>a.durum==="gecikti").reduce((s,a)=>s+a.tutar,0);
  const bekBorc = aylar.filter(a=>a.durum==="bekliyor").reduce((s,a)=>s+a.tutar,0);
  const topBorc = gecBorc+bekBorc;

  const entegrasyon = (() => {
    // adminData'dan al (Supabase'den çekilmiş)
    return adminData?.odemeEntegrasyon || null;
  })();
  const onlineOdemeAktif = entegrasyon?.aktif === true;

  const onlineOde = (ay) => {
    setSecilenAy(ay);
    setOdemeAdim(1);
    setOdemeModal(true);
  };

  const odemeyiBaslat = () => {
    if (!secilenAy || !entegrasyon) return;
    const url = entegrasyon.odemeSayfaUrl;
    if (url && url.startsWith("http")) {
      const p = new URLSearchParams({
        tutar: secilenAy.tutar, ay: secilenAy.key,
        daire: sakin.daireNo, blok: sakin.blok,
        site: sakin.siteIsmi, sakin: sakin.ad,
      });
      window.open(`${url}?${p}`, "_blank");
    } else {
      alert("Ödeme URL'i tanımlanmamış. Lütfen yöneticinizle iletişime geçin.");
      return;
    }
    // Adım 2'ye geç — ödeme tamamlandı mı sorusu
    setOdemeAdim(2);
  };

  // Sakin "Ödemeyi Tamamladım" dedi → sistemi güncelle
  const odemeOnayla = async () => {
    if (!secilenAy) { setOdemeAdim(3); return; }
    if (!sakin.daireId) {
      setOdemeAdim(3);
      return;
    }
    const bugun = new Date().toISOString().split("T")[0];
    const key = `${sakin.daireId}_${secilenAy.key}`;
    try {
      // localStorage'daki admin verisini güncelle
      const mevcutData = await supabaseVeriCek();
      if (mevcutData) {
        const mevcutOdeme = mevcutData.daireOdemeler?.[key] || { aidat: {}, flat: { tutar: 0, tarih: "" }, diger: [] };
        const yeniData = {
          ...mevcutData,
          daireOdemeler: {
            ...mevcutData.daireOdemeler,
            [key]: { ...mevcutOdeme, aidat: { durum: "odendi", tarih: bugun } },
          },
        };
        await supabaseVeriYaz(yeniData);
        if (setState) {
          setState(prev => ({
            ...prev,
            aidat: prev.aidat.map(a =>
              a.key === secilenAy.key ? { ...a, durum: "odendi", tarih: bugun } : a
            ),
          }));
        }
      }
    } catch(e) { console.error(e); }
    setOdemeAdim(3);
  };

  const cfg = { odendi:{l:t.paid,bg:"#d1fae5",c:"#065f46",ico:"✓"}, gecikti:{l:t.late,bg:"#fee2e2",c:"#991b1b",ico:"!"},  bekliyor:{l:t.pending,bg:"#fef3c7",c:"#92400e",ico:"○"} };

  // Buton her zaman görünür, aktif değilse grayed out ve tıklanamaz
  const OdemeButon = ({ ay, kucuk = false }) => {
    if (ay.durum === "odendi") return null;
    if (!onlineOdemeAktif) {
      return (
        <div style={{ fontSize: kucuk ? 10 : 11, color: "#94a3b8", background: "#f1f5f9", borderRadius: 8, padding: kucuk ? "4px 8px" : "5px 10px", whiteSpace: "nowrap", cursor: "default" }}>
          💳 Ödeme pasif
        </div>
      );
    }
    return (
      <button onClick={() => onlineOde(ay)} style={{
        background: "linear-gradient(135deg,#3b82f6,#6366f1)", color: "white", border: "none",
        borderRadius: 9, padding: kucuk ? "5px 10px" : "6px 14px", fontSize: kucuk ? 11 : 12,
        fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap"
      }}>
        💳 {kucuk ? "Öde" : "Online Öde"}
      </button>
    );
  };

  return (
    <div className="sp-panel">
      <div className="sp-ptitle">{t.dues}</div>
      <div className="sp-psub">{sakin.blok} {t.block} · {t.apartment} {sakin.daireNo}</div>

      {topBorc>0 ? (
        <div style={{background:"linear-gradient(135deg,#92400e,#b45309)",borderRadius:14,padding:"14px 18px",marginBottom:14,color:"white"}}>
          <div style={{fontSize:12,color:"#fde68a",fontWeight:600,marginBottom:4}}>⚠️ Toplam Ödenmemiş Borç</div>
          <div style={{fontSize:32,fontWeight:900,marginBottom:10}}>₺{topBorc.toLocaleString()}</div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
            {gecBorc>0&&<div style={{background:"rgba(0,0,0,0.25)",borderRadius:8,padding:"6px 12px",fontSize:12}}>
              <div style={{color:"#fca5a5",fontSize:10}}>Gecikmiş ({gecikti} ay)</div><div style={{fontWeight:700}}>₺{gecBorc.toLocaleString()}</div>
            </div>}
            {bekBorc>0&&<div style={{background:"rgba(0,0,0,0.25)",borderRadius:8,padding:"6px 12px",fontSize:12}}>
              <div style={{color:"#fde68a",fontSize:10}}>Bekleyen ({bekliyor} ay)</div><div style={{fontWeight:700}}>₺{bekBorc.toLocaleString()}</div>
            </div>}
            <div style={{marginLeft:"auto"}}>
              {onlineOdemeAktif
                ? <button onClick={()=>onlineOde(aylar.find(a=>a.durum!=="odendi"))} style={{background:"white",color:"#92400e",border:"none",borderRadius:10,padding:"8px 16px",fontWeight:700,fontSize:13,cursor:"pointer"}}>💳 Tümünü Öde</button>
                : <div style={{background:"rgba(255,255,255,0.15)",borderRadius:10,padding:"6px 12px",fontSize:12,color:"rgba(255,255,255,0.6)"}}>💳 Online ödeme kapalı</div>
              }
            </div>
          </div>
        </div>
      ) : (
        <div style={{background:"linear-gradient(135deg,#064e3b,#065f46)",borderRadius:12,padding:"12px 16px",marginBottom:14,display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:20}}>✅</span>
          <div><div style={{fontSize:13,color:"#6ee7b7",fontWeight:600}}>Borcunuz Yok</div><div style={{fontSize:12,color:"#a7f3d0"}}>Tüm aidatlar ödenmiş.</div></div>
        </div>
      )}

      <div className="sp-og">
        <div className="sp-ok" style={{background:"#d1fae5"}}><div className="sp-okn">{odendi}</div><div className="sp-okl">{t.paid}</div></div>
        <div className="sp-ok" style={{background:"#fef3c7"}}><div className="sp-okn">{bekliyor}</div><div className="sp-okl">{t.pending}</div></div>
        <div className="sp-ok" style={{background:"#fee2e2"}}><div className="sp-okn">{gecikti}</div><div className="sp-okl">{t.late}</div></div>
        <div className="sp-ok" style={{background:"#dbeafe"}}><div className="sp-okn">₺{toplamOdenen.toLocaleString()}</div><div className="sp-okl">{t.totalPaid}</div></div>
      </div>

      <div className="sp-alist">
        {aylar.map(a=>{
          const c=cfg[a.durum]||cfg.bekliyor;
          const solRenk=a.durum==="gecikti"?"#ef4444":a.durum==="bekliyor"?"#f59e0b":"#10b981";
          // eslint-disable-next-line no-unused-vars
    const odenebilir=(a.durum==="bekliyor"||a.durum==="gecikti")&&onlineOdemeAktif;
          return (
            <div key={a.key} className="sp-arow" style={{borderLeft:`3px solid ${solRenk}`,flexWrap:"wrap",gap:8}}>
              <div style={{display:"flex",alignItems:"center",gap:10,flex:1}}>
                <div className="sp-aico" style={{background:c.bg,color:c.c}}>{c.ico}</div>
                <div>
                  <div className="sp-aay">{ayLabel(a.key)}</div>
                  <div className="sp-atarih" style={{color:a.durum==="gecikti"?"#991b1b":a.durum==="bekliyor"?"#92400e":"#94a3b8"}}>
                    {a.tarih?`${a.tarih} tarihinde ödendi`:a.durum==="bekliyor"?"Ödeme bekleniyor":"Gecikmiş ödeme!"}
                  </div>
                </div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <div style={{textAlign:"right"}}>
                  <div className="sp-atutar" style={{color:solRenk}}>₺{a.tutar}</div>
                  <div className="sp-abdg" style={{background:c.bg,color:c.c}}>{c.l}</div>
                </div>
                {a.durum !== "odendi" && <OdemeButon ay={a} kucuk={true} />}
              </div>
            </div>
          );
        })}
      </div>

      {odemeModal&&secilenAy&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:300}}>
          <div style={{background:"white",borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,padding:24}}>

            {/* ADIM 1: Ödeme özeti + sayfaya git */}
            {odemeAdim===1&&(
              <>
                <div style={{fontSize:22,textAlign:"center",marginBottom:4}}>💳</div>
                <h3 style={{textAlign:"center",fontSize:16,fontWeight:800,marginBottom:4}}>Online Ödeme</h3>
                <p style={{textAlign:"center",fontSize:13,color:"#64748b",marginBottom:16}}>{ayLabel(secilenAy.key)} · {sakin.siteIsmi}</p>
                <div style={{background:"#f8fafc",borderRadius:12,padding:"14px 16px",marginBottom:16}}>
                  {[
                    ["Aidat Bedeli", `₺${secilenAy.tutar.toLocaleString()}`],
                    ["Dönem", ayLabel(secilenAy.key)],
                    ["Daire", `${sakin.blok} Blok - Daire ${sakin.daireNo}`],
                    ["Sakin", sakin.ad],
                  ].map(([k,v])=>(
                    <div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:13,marginBottom:6}}>
                      <span style={{color:"#64748b"}}>{k}</span><strong>{v}</strong>
                    </div>
                  ))}
                  <div style={{borderTop:"1px solid #e2e8f0",marginTop:10,paddingTop:10,display:"flex",justifyContent:"space-between",fontSize:15,fontWeight:800}}>
                    <span>Toplam</span><span style={{color:"#3b82f6"}}>₺{secilenAy.tutar.toLocaleString()}</span>
                  </div>
                </div>
                {entegrasyon?.aciklama&&<p style={{fontSize:12,color:"#64748b",textAlign:"center",marginBottom:12}}>{entegrasyon.aciklama}</p>}
                <div style={{background:"#fef3c7",borderRadius:10,padding:"10px 14px",marginBottom:14,fontSize:12,color:"#92400e"}}>
                  💡 Ödeme sayfası yeni sekmede açılacak. Ödemeyi tamamladıktan sonra buraya dönüp <strong>"Ödemeyi Tamamladım"</strong> butonuna basın.
                </div>
                <div style={{display:"flex",gap:10}}>
                  <button onClick={()=>setOdemeModal(false)} style={{flex:1,padding:12,background:"#f1f5f9",border:"none",borderRadius:10,cursor:"pointer",fontWeight:600,fontSize:13}}>İptal</button>
                  <button onClick={odemeyiBaslat} style={{flex:2,padding:12,background:"linear-gradient(135deg,#3b82f6,#6366f1)",color:"white",border:"none",borderRadius:10,cursor:"pointer",fontWeight:700,fontSize:14}}>
                    💳 Ödeme Sayfasını Aç
                  </button>
                </div>
              </>
            )}

            {/* ADIM 2: Ödeme tamamlama onayı */}
            {odemeAdim===2&&(
              <>
                <div style={{fontSize:36,textAlign:"center",marginBottom:8}}>⏳</div>
                <h3 style={{textAlign:"center",fontSize:16,fontWeight:800,marginBottom:6}}>Ödeme Yapıldı mı?</h3>
                <p style={{textAlign:"center",fontSize:13,color:"#64748b",marginBottom:20}}>
                  {ayLabel(secilenAy.key)} için <strong>₺{secilenAy.tutar.toLocaleString()}</strong> ödemesini tamamladıysanız onaylayın.
                </p>
                <div style={{background:"#fff7ed",borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:12,color:"#92400e"}}>
                  ⚠️ Yalnızca gerçekten ödeme yaptıysanız onaylayın. Sistem buna göre güncellenecek ve yönetici bilgilendirilecek.
                </div>
                <div style={{display:"flex",gap:10,flexDirection:"column"}}>
                  <button onClick={odemeOnayla} style={{padding:14,background:"linear-gradient(135deg,#10b981,#059669)",color:"white",border:"none",borderRadius:12,cursor:"pointer",fontWeight:800,fontSize:15}}>
                    ✅ Evet, Ödemeyi Tamamladım
                  </button>
                  <div style={{display:"flex",gap:8}}>
                    <button onClick={()=>{ const url=entegrasyon?.odemeSayfaUrl; if(url&&url.startsWith("http")){const p=new URLSearchParams({tutar:secilenAy.tutar,ay:secilenAy.key,daire:sakin.daireNo,blok:sakin.blok,site:sakin.siteIsmi,sakin:sakin.ad});window.open(`${url}?${p}`,"_blank");}}} style={{flex:1,padding:10,background:"#dbeafe",color:"#1e40af",border:"none",borderRadius:10,cursor:"pointer",fontWeight:600,fontSize:13}}>
                      🔄 Sayfayı Tekrar Aç
                    </button>
                    <button onClick={()=>setOdemeModal(false)} style={{flex:1,padding:10,background:"#f1f5f9",border:"none",borderRadius:10,cursor:"pointer",fontWeight:600,fontSize:13}}>
                      Daha Sonra
                    </button>
                  </div>
                </div>
              </>
            )}

            {/* ADIM 3: Başarı */}
            {odemeAdim===3&&(
              <>
                <div style={{fontSize:48,textAlign:"center",marginBottom:10}}>🎉</div>
                <h3 style={{textAlign:"center",fontSize:17,fontWeight:800,color:"#065f46",marginBottom:6}}>Ödeme Kaydedildi!</h3>
                <p style={{textAlign:"center",fontSize:13,color:"#64748b",marginBottom:16}}>
                  {ayLabel(secilenAy.key)} aidatınız <strong style={{color:"#10b981"}}>ödendi</strong> olarak işaretlendi.
                </p>
                <div style={{background:"#d1fae5",borderRadius:12,padding:"14px 16px",marginBottom:16}}>
                  {[
                    ["Dönem", ayLabel(secilenAy.key)],
                    ["Tutar", `₺${secilenAy.tutar.toLocaleString()}`],
                    ["Tarih", new Date().toLocaleDateString("tr-TR")],
                    ["Durum", "✅ Ödendi"],
                  ].map(([k,v])=>(
                    <div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:13,marginBottom:4}}>
                      <span style={{color:"#065f46"}}>{k}</span><strong style={{color:"#065f46"}}>{v}</strong>
                    </div>
                  ))}
                </div>
                <button onClick={()=>setOdemeModal(false)} style={{width:"100%",padding:13,background:"linear-gradient(135deg,#10b981,#059669)",color:"white",border:"none",borderRadius:12,cursor:"pointer",fontWeight:700,fontSize:14}}>
                  Tamam
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
function SiteHarcamalari({ state, t }) {
  const [filtre, setFiltre] = useState("hepsi");
  const katCfg = { bakim:{l:"Bakım",e:"🔧",bg:"#dbeafe",c:"#185fa5"}, temizlik:{l:"Temizlik",e:"🧹",bg:"#d1fae5",c:"#0f6e56"}, bahce:{l:"Bahçe",e:"🌿",bg:"#dcfce7",c:"#3b6d11"}, havuz:{l:"Havuz",e:"💧",bg:"#cffafe",c:"#0891b2"}, elektrik:{l:"Elektrik",e:"⚡",bg:"#fef3c7",c:"#854f0b"}, guvenlik:{l:"Güvenlik",e:"🔒",bg:"#ede9fe",c:"#533489"} };
  const liste = filtre==="hepsi" ? state.siteHarcamalar : state.siteHarcamalar.filter(h=>h.kategori===filtre);
  const toplam = liste.reduce((a,b)=>a+b.tutar,0);
  return (
    <div className="sp-panel">
      <div className="sp-ptitle">{t.expenses}</div>
      <div className="sp-psub">Ortak alan giderleri</div>
      <div className="sp-htop"><div style={{fontSize:12,opacity:0.7,marginBottom:2}}>{t.totalExpense}</div><div style={{fontSize:26,fontWeight:800}}>₺{toplam.toLocaleString()}</div></div>
      <div className="sp-kat">
        <button className={`sp-kb ${filtre==="hepsi"?"on":""}`} onClick={()=>setFiltre("hepsi")}>Tümü</button>
        {Object.entries(katCfg).map(([k,v])=>(
          <button key={k} className={`sp-kb ${filtre===k?"on":""}`} style={filtre===k?{background:v.bg,color:v.c,borderColor:v.c}:{}} onClick={()=>setFiltre(k)}>{v.l}</button>
        ))}
      </div>
      <div className="sp-hlist">
        {liste.sort((a,b)=>b.tarih.localeCompare(a.tarih)).map(h=>{
          const kat=katCfg[h.kategori]||{e:"📋",bg:"#f1f5f9",c:"#475569"};
          return (
            <div key={h.id} className="sp-hrow">
              <div className="sp-hico" style={{background:kat.bg,color:kat.c}}>{kat.e}</div>
              <div style={{flex:1}}>
                <div className="sp-hac">{h.aciklama}</div>
                <div className="sp-hdt">{h.tarih}</div>
                {h.dosyaAdi&&<div style={{marginTop:4,display:"flex",alignItems:"center",gap:4,fontSize:11,color:"#3b82f6"}}>
                  <Icon name="clip" size={11}/>{h.dosyaAdi}
                  <span style={{background:"#dbeafe",color:"#185fa5",padding:"1px 6px",borderRadius:10,fontSize:10,fontWeight:600}}>PDF</span>
                </div>}
              </div>
              <div className="sp-hamt">₺{h.tutar.toLocaleString()}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ============================================================
// DUYURULAR — Dosya görüntüle/indir
// ============================================================
function Duyurular({ state, t }) {
  const [selected, setSelected] = useState(null);
  const [cozulenUrlMap, setCozulenUrlMap] = useState({});

  // Duyuru dosya URL'lerini çöz
  useEffect(() => {
    const coz = async () => {
      const yeni = {};
      for (const d of state.duyurular) {
        if (!d.dosyaUrl) continue;
        // Tüm dosyalar base64 olarak Supabase'de saklanır
        if (d.dosyaUrl && !d.dosyaUrl.startsWith("__")) {
          yeni[d.id] = d.dosyaUrl;
        }
      }
      setCozulenUrlMap(yeni);
    };
    coz();
  }, [state.duyurular]); // eslint-disable-line react-hooks/exhaustive-deps

  const dosyaIco = (tur="") => {
    if (tur==="pdf") return "📄";
    if (tur==="doc"||tur==="docx") return "📝";
    if (tur==="xls"||tur==="xlsx") return "📊";
    if (["jpg","jpeg","png","gif","tif","tiff","webp"].includes(tur)) return "🖼️";
    return "📎";
  };
  return (
    <div className="sp-panel">
      <div className="sp-ptitle">{t.announcements}</div>
      <div className="sp-psub">Site yönetiminin duyuruları</div>
      {state.duyurular.length===0&&<div style={{textAlign:"center",color:"#94a3b8",padding:32}}>{t.noAnnouncement}</div>}
      {state.duyurular.map(d=>{
        const gercekUrl = cozulenUrlMap[d.id] || "";
        return (
        <div key={d.id} className="sp-dkart">
          <div className="sp-dhdr" onClick={()=>setSelected(selected?.id===d.id?null:d)}>
            <div>
              <div className="sp-dbaslik">{d.baslik}</div>
              <div className="sp-dtarih">{d.tarih}</div>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              {d.dosyaAdi&&<span style={{fontSize:16}}>{dosyaIco(d.dosyaTur)}</span>}
              <span style={{fontSize:12,color:"#94a3b8"}}>{selected?.id===d.id?"▲":"▼"}</span>
            </div>
          </div>
          {selected?.id===d.id&&(
            <div className="sp-dbody" onClick={e=>e.stopPropagation()}>
              <p>{d.icerik}</p>
              {d.dosyaAdi&&(
                <div className="sp-ddosya">
                  <span style={{fontSize:20}}>{dosyaIco(d.dosyaTur)}</span>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,color:"#1e293b",fontWeight:600}}>{d.dosyaAdi}</div>
                    <div style={{fontSize:11,color:"#64748b"}}>{d.dosyaTur?.toUpperCase()} dosyası</div>
                  </div>
                  <div style={{display:"flex",gap:6}}>
                    {gercekUrl?(
                      <>
                        <a href={gercekUrl} target="_blank" rel="noopener noreferrer"
                          style={{background:"#3b82f6",color:"white",border:"none",borderRadius:8,padding:"6px 12px",fontSize:12,textDecoration:"none",fontWeight:600}}>
                          👁️ {t.viewFile}
                        </a>
                        <a href={gercekUrl} download={d.dosyaAdi}
                          style={{background:"#d1fae5",color:"#065f46",border:"none",borderRadius:8,padding:"6px 12px",fontSize:12,textDecoration:"none",fontWeight:600}}>
                          ⬇️ İndir
                        </a>
                      </>
                    ):(
                      <span style={{fontSize:11,color:"#94a3b8",background:"#f1f5f9",padding:"6px 10px",borderRadius:8}}>
                        📎 Dosya bilgisi kaydedilmiş, içerik mevcut değil
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        );
      })}
    </div>
  );
}

// ============================================================
// ARIZA FORMU
// ============================================================
function ArizaFormu({ sakin, state, setState, t }) {
  const [tab, setTab] = useState("form");
  const [form, setForm] = useState({ baslik:"", aciklama:"", konum:"" });
  const [gonderildi, setGonderildi] = useState(false);
  const durumCfg = { bildirildi:{l:t.statusNew,bg:"#fee2e2",c:"#991b1b"}, devamEdiyor:{l:t.statusProgress,bg:"#fef3c7",c:"#92400e"}, cozuldu:{l:t.statusDone,bg:"#d1fae5",c:"#065f46"} };
  const gonder = async () => {
    if (!form.baslik.trim()||!form.aciklama.trim()) return;
    const yeniAriza = {
      id: Date.now(),
      siteId: sakin.siteId,
      daireId: sakin.daireId,
      sakinId: sakin.id,
      sakinAd: sakin.ad,
      sakinTel: sakin.tel,
      tarih: new Date().toISOString().split("T")[0],
      ...form,
      durum: "bildirildi",
      adminNot: "",
    };
    setState(s => ({ ...s, arizalar: [yeniAriza, ...s.arizalar] }));
    // Supabase'e yaz (fire-and-forget)
    supabaseVeriCek().then(d => {
      if (d) supabaseVeriYaz({ ...d, arizalar: [yeniAriza, ...(d.arizalar || [])] });
    });
    setForm({ baslik:"", aciklama:"", konum:"" });
    setGonderildi(true);
    setTimeout(() => { setGonderildi(false); setTab("liste"); }, 2000);
  };
  const benimArizalar = state.arizalar.filter(a=>a.sakinId===sakin.id);
  return (
    <div className="sp-panel">
      <div className="sp-ptitle">{t.faultForm}</div>
      <div className="sp-psub">Arıza bildirim ve takip</div>
      <div className="sp-stabs">
        <button className={`sp-stab ${tab==="form"?"on":""}`} onClick={()=>setTab("form")}>{t.submitFault}</button>
        <button className={`sp-stab ${tab==="liste"?"on":""}`} onClick={()=>setTab("liste")}>{t.records} ({benimArizalar.length})</button>
      </div>
      {tab==="form"&&(
        <div>
          {gonderildi&&<div style={{background:"#d1fae5",color:"#065f46",padding:"12px 16px",borderRadius:10,marginBottom:14,fontWeight:600,display:"flex",alignItems:"center",gap:8}}>
            <Icon name="check" size={16}/> {t.faultSent}
          </div>}
          <div className="sp-sf"><label>{t.faultTitle} *</label><input value={form.baslik} onChange={e=>setForm(p=>({...p,baslik:e.target.value}))} placeholder="Örn: Su sızıntısı..."/></div>
          <div className="sp-sf"><label>{t.faultLocation}</label><input value={form.konum} onChange={e=>setForm(p=>({...p,konum:e.target.value}))} placeholder="Örn: Mutfak, Balkon..."/></div>
          <div className="sp-sf"><label>{t.faultDesc} *</label><textarea value={form.aciklama} onChange={e=>setForm(p=>({...p,aciklama:e.target.value}))} rows={5} placeholder="Arızayı detaylı açıklayın..."/></div>
          <button className="sp-gsend" onClick={gonder} disabled={!form.baslik.trim()||!form.aciklama.trim()}>{t.submitFault}</button>
        </div>
      )}
      {tab==="liste"&&(
        <div>
          {benimArizalar.map(a=>{
            const cfg=durumCfg[a.durum]||durumCfg.bildirildi;
            return (
              <div key={a.id} className="sp-skart">
                <div className="sp-skh">
                  <span className="sp-stur" style={{background:cfg.bg,color:cfg.c}}>{a.baslik}</span>
                  <span className="sp-sdur" style={{background:cfg.bg,color:cfg.c}}>{cfg.l}</span>
                </div>
                <div className="sp-sbas">{a.aciklama}</div>
                {a.konum&&<div style={{fontSize:12,color:"#94a3b8"}}>📍 {a.konum}</div>}
                <div className="sp-salt"><span>{a.tarih}</span></div>
                {a.adminNot&&<div style={{marginTop:8,background:"#f0fdf4",borderRadius:8,padding:"8px 12px",fontSize:12,color:"#065f46",borderLeft:"3px solid #10b981"}}>
                  <strong>{t.adminNote}:</strong> {a.adminNot}
                </div>}
              </div>
            );
          })}
          {benimArizalar.length===0&&<div style={{textAlign:"center",color:"#94a3b8",padding:24}}>Arıza bildiriminiz yok.</div>}
        </div>
      )}
    </div>
  );
}

// ============================================================
// ŞİKAYET & GÖRÜŞ
// ============================================================
function SikayetGorusAcil({ sakin, state, setState, t, setAcilAcik }) {
  const [tab, setTab] = useState("liste");
  const [form, setForm] = useState({ tur:"sikayet", baslik:"", icerik:"" });
  const turCfg = { sikayet:{l:"Şikayet",bg:"#fee2e2",c:"#991b1b"}, oneri:{l:"Öneri",bg:"#dbeafe",c:"#185fa5"}, gorus:{l:"Görüş",bg:"#ede9fe",c:"#533489"} };
  const durumCfg = { bekliyor:{l:"Bekliyor",bg:"#fef3c7",c:"#92400e"}, inceleniyor:{l:"İnceleniyor",bg:"#dbeafe",c:"#185fa5"}, cozuldu:{l:"Çözüldü",bg:"#d1fae5",c:"#065f46"}, aktif:{l:"Aktif",bg:"#d1fae5",c:"#065f46"} };
  const gonder = async () => {
    if (!form.baslik.trim()||!form.icerik.trim()) return;
    const yeniSikayet = {
      id: Date.now(),
      siteId: sakin.siteId,
      daireId: sakin.daireId,
      kAd: sakin.ad,
      sakinTel: sakin.tel,
      tarih: new Date().toISOString().split("T")[0],
      ...form,
      durum: "bekliyor",
    };
    setState(s => ({ ...s, sikayet: [yeniSikayet, ...s.sikayet] }));
    // Supabase'e yaz (fire-and-forget)
    supabaseVeriCek().then(d => {
      if (d) supabaseVeriYaz({ ...d, sakinSikayetler: [yeniSikayet, ...(d.sakinSikayetler || [])] });
    });
        setForm({ tur:"sikayet", baslik:"", icerik:"" });
    setTab("liste");
  };
  return (
    <div className="sp-panel">
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:4}}>
        <div><div className="sp-ptitle">{t.complaints}</div><div className="sp-psub">Yönetime iletmek istediğiniz konular</div></div>
        <button className="sp-acil" onClick={()=>setAcilAcik(true)}>🚨 {t.emergency}</button>
      </div>
      <div className="sp-stabs">
        <button className={`sp-stab ${tab==="liste"?"on":""}`} onClick={()=>setTab("liste")}>{t.records} ({state.sikayet.length})</button>
        <button className={`sp-stab ${tab==="yeni"?"on":""}`} onClick={()=>setTab("yeni")}>{t.newRecord}</button>
      </div>
      {tab==="liste"&&(
        <div>
          {state.sikayet.map(s=>{
            const tur=turCfg[s.tur]||{l:s.tur,bg:"#f1f5f9",c:"#475569"};
            const dur=durumCfg[s.durum]||durumCfg.bekliyor;
            return (
              <div key={s.id} className="sp-skart">
                <div className="sp-skh">
                  <span className="sp-stur" style={{background:tur.bg,color:tur.c}}>{tur.l}</span>
                  <span className="sp-sdur" style={{background:dur.bg,color:dur.c}}>{dur.l}</span>
                </div>
                <div className="sp-sbas">{s.baslik}</div>
                <div className="sp-sice">{s.icerik}</div>
                <div className="sp-salt"><span>{s.kAd}</span><span>{s.tarih}</span></div>
              </div>
            );
          })}
        </div>
      )}
      {tab==="yeni"&&(
        <div>
          <div style={{display:"flex",gap:6,marginBottom:12}}>
            {Object.entries(turCfg).map(([k,v])=>(
              <button key={k} className="sp-sturb" style={form.tur===k?{background:v.bg,color:v.c,borderColor:v.c}:{}} onClick={()=>setForm(p=>({...p,tur:k}))}>{v.l}</button>
            ))}
          </div>
          <div className="sp-sf"><label>{t.title}</label><input value={form.baslik} onChange={e=>setForm(p=>({...p,baslik:e.target.value}))}/></div>
          <div className="sp-sf"><label>{t.content}</label><textarea value={form.icerik} onChange={e=>setForm(p=>({...p,icerik:e.target.value}))} rows={5}/></div>
          <button className="sp-gsend" onClick={gonder} disabled={!form.baslik.trim()||!form.icerik.trim()}>{t.sendTo}</button>
        </div>
      )}
    </div>
  );
}

// ============================================================
// ACİL DURUM MODAL
// ============================================================
function AcilModal({ onClose, t, sakin, acilTelNo, acilYonetici }) {
  return (
    <div className="sp-aov" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="sp-abox">
        <div style={{fontSize:40,marginBottom:8}}>🚨</div>
        <h2 style={{fontSize:18,fontWeight:800,color:"#0f172a",marginBottom:4}}>{t.emergency}</h2>
        <p style={{fontSize:13,color:"#64748b",marginBottom:16}}>{acilYonetici} — {sakin?.siteIsmi}</p>
        <a href={`tel:${acilTelNo}`} className="sp-atel"><Icon name="phone" size={18}/> {acilTelNo}</a>
        <div className="sp-agrid">
          {["🔥 Yangın","💧 Su Baskını","⚡ Elektrik Arızası","🚪 Asansör Arızası","🏥 Sağlık Acili","🔒 Güvenlik"].map(item=>(
            <div key={item} className="sp-aitem">{item}</div>
          ))}
        </div>
        <button className="sp-akapat" onClick={onClose}>{t.close}</button>
      </div>
    </div>
  );
}

// ============================================================
// ANA UYGULAMA
// ============================================================
export default function SakinPaneli() {
  // Oturum localStorage'dan restore et
  const [sakin, setSakinRaw] = useState(() => {
    try {
      const s = localStorage.getItem("sakin_session");
      return s ? JSON.parse(s) : null;
    } catch { return null; }
  });
  const sakinSlugMap = {
    "mesajlar": "/sakin/mesajlar",
    "aidat": "/sakin/aidat",
    "harcamalar": "/sakin/harcamalar",
    "duyurular": "/sakin/duyurular",
    "ariza": "/sakin/ariza",
    "sikayet": "/sakin/sikayet",
    "profil": "/sakin/profil",
  };
  const urlToSayfa = (path) => {
    const validPages = ["mesajlar","aidat","harcamalar","duyurular","ariza","sikayet","profil"];
    const parts = path.replace(/^\//, "").split("/").filter(Boolean);
    if (parts[0] === "sakin" && parts[1] && validPages.includes(parts[1])) return parts[1];
    return "mesajlar";
  };
  const [sayfa, setSayfaRaw] = useState(() => urlToSayfa(window.location.pathname));
  const setSayfa = (s) => {
    setSayfaRaw(s);
    const url = sakinSlugMap[s] || "/sakin/mesajlar";
    window.history.pushState({ sayfa: s }, "", url);
  };

  // Geri tusu icin popstate dinle
  useEffect(() => {
    const validPages = ["mesajlar","aidat","harcamalar","duyurular","ariza","sikayet","profil"];
    const handlePop = () => {
      const parts = window.location.pathname.replace(/^\//, "").split("/").filter(Boolean);
      const s = (parts[0] === "sakin" && parts[1] && validPages.includes(parts[1])) ? parts[1] : "mesajlar";
      setSayfaRaw(s);
    };
    window.addEventListener("popstate", handlePop);
    return () => window.removeEventListener("popstate", handlePop);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const [lang, setLang]           = useState(() => localStorage.getItem("sakin_lang") || "TR");
  const [acilAcik, setAcilAcik]   = useState(false);
  const [state, setState]         = useState(INIT_STATE);
  const [adminData, setAdminData] = useState(null);

  // sakin set edilince localStorage'a da yaz
  const setSakin = (val) => {
    setSakinRaw(val);
    if (val) {
      try { localStorage.setItem("sakin_session", JSON.stringify(val)); } catch {}
    } else {
      localStorage.removeItem("sakin_session");
    }
  };

  // Dil değişince localStorage'a kaydet
  const setLangPersist = (l) => {
    setLang(l);
    try { localStorage.setItem("sakin_lang", l); } catch {}
  };

  const t = T[lang];

  // Sayfa yenilenince oturum varsa adminData'dan verileri yükle (Supabase async useEffect ayrıca çeker)
  useEffect(() => {
    if (!sakin || !adminData) return;
    const data = adminData;
    if (!data) return;
    setAdminData(data);
    const siteId = sakin.siteId;
    const siteHarcamalar = (data.siteGiderleri||[]).filter(g=>g.siteId===siteId).map(g=>({ id:g.id,tarih:g.tarih,tutar:g.tutar,aciklama:g.aciklama,kategori:g.kategori,dosyaAdi:g.dosyaAdi||"" }));
    const cozDosyaUrl = (url) => {
      if (!url) return "";
      if (url.startsWith("__ref:") || url.startsWith("__idb:")) return ""; // Eski format
      return url;
    };
    const duyurular = (data.duyurular||[]).filter(d=>d.siteId===0||d.siteId===siteId).map(d=>({ id:d.id,siteId:d.siteId,baslik:d.baslik,icerik:d.icerik,tarih:d.tarih,dosyaAdi:d.dosyaAdi||"",dosyaTur:d.dosyaTur||"",dosyaUrl:cozDosyaUrl(d.dosyaUrl) }));
    const daireId = sakin.daireId;
    let aidatListesi = INIT_STATE.aidat;
    if (daireId && data.daireOdemeler) {
      const arr = [];
      // Site kayıt tarihinden başlat (yoksa 6 ay öncesi)
      const siteKayit = data.siteler?.find(s=>s.id===siteId)?.kayitTarihi;
      const bas = siteKayit ? new Date(siteKayit) : (() => { const d=new Date(); d.setMonth(d.getMonth()-1); d.setDate(1); return d; })();
      const gun = new Date();
      let d2 = new Date(bas);
      while (d2<=gun) {
        const key=`${d2.getFullYear()}-${String(d2.getMonth()+1).padStart(2,"0")}`;
        const od=data.daireOdemeler[`${daireId}_${key}`];
        arr.unshift({ key, durum:od?.aidat?.durum||"bekliyor", tarih:od?.aidat?.tarih||"", tutar:getDönemTutariSP(data.aidatTarihleri,sakin.siteId,key,sakin.aidatBedeli||800) });
        d2.setMonth(d2.getMonth()+1);
      }
      if (arr.length>0) aidatListesi=arr;
    }
    // Mesaj geçmişini de restore et
    let mesajListesi = INIT_STATE.mesajlar;
    // Mesajlar yukle useEffect'teki Supabase çekiminde gelir

    // Arızaları restore et — bu sakinle ilgili olanlar
    const arizalar = (data.arizalar || []).filter(a =>
      a.sakinId === sakin.id || a.daireId === sakin.daireId
    );

    // Şikayetleri restore et
    const sikayetler = (data.sakinSikayetler || []).filter(s =>
      s.daireId === sakin.daireId || s.kAd === sakin.ad
    );

    setState(prev => ({
      ...prev,
      siteHarcamalar: siteHarcamalar.length > 0 ? siteHarcamalar : prev.siteHarcamalar,
      duyurular: duyurular.length > 0 ? duyurular : prev.duyurular,
      aidat: aidatListesi,
      mesajlar: mesajListesi,
      arizalar: arizalar.length > 0 ? arizalar : prev.arizalar,
      sikayet: sikayetler.length > 0 ? sikayetler : prev.sikayet,
    }));

    // Mesajlar Supabase'de — admin paneli Supabase'den okur
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const nav = [
    { id:"mesajlar",  label:t.messages,      icon:"chat"    },
    { id:"aidat",     label:t.dues,           icon:"money"   },
    { id:"harcamalar",label:t.expenses,       icon:"expense" },
    { id:"duyurular", label:t.announcements,  icon:"bell"    },
    { id:"ariza",     label:t.faults,         icon:"wrench"  },
    { id:"sikayet",   label:t.complaints,     icon:"flag"    },
  ];

  const handleLogin = async (sakinObj, aData) => {
  setSakin(sakinObj);
  // Login sonrası URL'yi /sakin/mesajlar'a ayarla
  window.history.replaceState({ sayfa: "mesajlar" }, "", "/sakin/mesajlar");
  setSayfaRaw("mesajlar");

  // Önce Supabase'den güncel veriyi çek
  let data = aData;
  try {
    const SUPA_URL = process.env.REACT_APP_SUPABASE_URL;
    const SUPA_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;
    if (SUPA_URL && SUPA_KEY) {
      const res = await fetch(
        `${SUPA_URL}/rest/v1/app_data?id=eq.1&select=veri`,
        { headers: { apikey: SUPA_KEY, Authorization: `Bearer ${SUPA_KEY}` } }
      );
      const rows = await res.json();
      if (rows[0]?.veri) {
        data = rows[0].veri;
      }
    }
  } catch (e) {
    console.error("Supabase veri çekme hatası:", e);
  }

  if (!data) {
    setAdminData(null);
    return; // Supabase'e bağlanamadı
  }

  setAdminData(data);
  if (!data) return;

  const siteId = sakinObj.siteId;
  const siteHarcamalar = (data.siteGiderleri || [])
    .filter(g => g.siteId === siteId)
    .map(g => ({ id: g.id, tarih: g.tarih, tutar: g.tutar, aciklama: g.aciklama, kategori: g.kategori, dosyaAdi: g.dosyaAdi || "" }));

  const cozDosyaUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("__ref:")) {
      return ""; // __ref: eski format — Supabase'de yok
    }
    return url;
  };

  const duyurular = (data.duyurular || [])
    .filter(d => d.siteId === 0 || d.siteId === siteId)
    .map(d => ({ id: d.id, siteId: d.siteId, baslik: d.baslik, icerik: d.icerik, tarih: d.tarih, dosyaAdi: d.dosyaAdi || "", dosyaTur: d.dosyaTur || "", dosyaUrl: cozDosyaUrl(d.dosyaUrl) }));

  const daireId = sakinObj.daireId;
  let aidatListesi = INIT_STATE.aidat;
  if (daireId && data.daireOdemeler) {
    const arr = [];
    const siteKayit = data.siteler?.find(s => s.id === siteId)?.kayitTarihi;
    const bas = siteKayit ? new Date(siteKayit) : (() => { const d = new Date(); d.setMonth(d.getMonth() - 1); d.setDate(1); return d; })();
    const gun = new Date();
    let d2 = new Date(bas);
    while (d2 <= gun) {
      const key = `${d2.getFullYear()}-${String(d2.getMonth() + 1).padStart(2, "0")}`;
      const od = data.daireOdemeler[`${daireId}_${key}`];
      arr.unshift({ key, durum: od?.aidat?.durum || "bekliyor", tarih: od?.aidat?.tarih || "", tutar: getDönemTutariSP(data.aidatTarihleri,sakinObj.siteId,key,sakinObj.aidatBedeli||800) });
      d2.setMonth(d2.getMonth() + 1);
    }
    if (arr.length > 0) aidatListesi = arr;
  }

  const arizalar = (data.arizalar || []).filter(a => a.sakinId === sakinObj.id || a.daireId === sakinObj.daireId);
  const sikayetler = (data.sakinSikayetler || []).filter(s => s.daireId === sakinObj.daireId || s.kAd === sakinObj.ad);

  setState(prev => ({
    ...prev,
    siteHarcamalar: siteHarcamalar.length > 0 ? siteHarcamalar : prev.siteHarcamalar,
    duyurular: duyurular.length > 0 ? duyurular : prev.duyurular,
    aidat: aidatListesi,
    arizalar: arizalar.length > 0 ? arizalar : prev.arizalar,
    sikayet: sikayetler.length > 0 ? sikayetler : prev.sikayet,
  }));

  // Mesajlar Supabase'de saklanır — localStorage chat init gerekmez
};

  // eslint-disable-next-line no-unused-vars
  const refreshAdminData = async () => { const d = await supabaseVeriCek(); if (d) setAdminData(d); };

  // Aktivite bazlı oturum timeout — 5 dakika hareketsizlikte çıkış
  useEffect(() => {
    if (!sakin) return;
    let timer;
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        setSakin(null);
        setSayfaRaw("mesajlar");
        setState(INIT_STATE);
        setAdminData(null);
        window.history.replaceState({}, "", "/sakin");
      }, 5 * 60 * 1000);
    };
    const events = ["click","touchstart","keydown","scroll"];
    events.forEach(e => window.addEventListener(e, resetTimer));
    resetTimer();
    return () => {
      clearTimeout(timer);
      events.forEach(e => window.removeEventListener(e, resetTimer));
    };
  }, [sakin]); // eslint-disable-line react-hooks/exhaustive-deps

  const cikisYap = () => {
    if (window.confirm(t.confirmLogout || "Çıkış yapmak istediğinize emin misiniz?")) {
      setSakin(null);
      setSayfaRaw("mesajlar");
      setState(INIT_STATE);
      setAdminData(null);
      window.history.replaceState({}, "", "/sakin");
    }
  };

  const [siteBilgiState, setSiteBilgiState] = useState(null);
  // Site bilgisi adminData'dan gelir (Supabase'den zaten çekilmiş)
  useEffect(() => {
    if (!sakin || !adminData) return;
    const sb = adminData.siteler?.find(s => s.id === sakin.siteId);
    if (sb) setSiteBilgiState(sb);
  }, [sakin, adminData]);

  // Supabase'den güncel veri çek ve tüm state'i güncelle
  useEffect(() => {
    if (!sakin) return;
    const yukle = async () => {
      let data = null;
      try {
        const SUPA_URL = process.env.REACT_APP_SUPABASE_URL;
        const SUPA_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;
        if (SUPA_URL && SUPA_KEY) {
          const res = await fetch(
            `${SUPA_URL}/rest/v1/app_data?id=eq.1&select=veri`,
            { headers: { apikey: SUPA_KEY, Authorization: `Bearer ${SUPA_KEY}` } }
          );
          const rows = await res.json();
          if (rows[0]?.veri) {
            data = rows[0].veri;
            // Veri Supabase'den geldi, localStorage cache gerekmez
          }
        }
      } catch {}
      if (!data) {
        // Supabase bağlanamadı, data null kalacak
      }
      if (!data) return;
      setAdminData(data);
      const siteId = sakin.siteId;
      const siteHarcamalar = (data.siteGiderleri||[]).filter(g=>g.siteId===siteId).map(g=>({id:g.id,tarih:g.tarih,tutar:g.tutar,aciklama:g.aciklama,kategori:g.kategori,dosyaAdi:g.dosyaAdi||""}));
      const cozDosyaUrl = (url) => { if(!url)return""; if(url.startsWith("__ref:")||url.startsWith("__idb:"))return""; return url; };
      const duyurular = (data.duyurular||[]).filter(d=>d.siteId===0||d.siteId===siteId).map(d=>({id:d.id,siteId:d.siteId,baslik:d.baslik,icerik:d.icerik,tarih:d.tarih,dosyaAdi:d.dosyaAdi||"",dosyaTur:d.dosyaTur||"",dosyaUrl:cozDosyaUrl(d.dosyaUrl)}));
      const daireId = sakin.daireId;
      let aidatListesi = INIT_STATE.aidat;
      if (daireId && data.daireOdemeler) {
        const arr = [];
        const siteKayit = data.siteler?.find(s=>s.id===siteId)?.kayitTarihi;
        const bas = siteKayit ? new Date(siteKayit) : (()=>{const d=new Date();d.setMonth(d.getMonth()-1);d.setDate(1);return d;})();
        const gun = new Date();
        let d2 = new Date(bas);
        while (d2<=gun) {
          const key=`${d2.getFullYear()}-${String(d2.getMonth()+1).padStart(2,"0")}`;
          const od=data.daireOdemeler[`${daireId}_${key}`];
          arr.unshift({key,durum:od?.aidat?.durum||"bekliyor",tarih:od?.aidat?.tarih||"",tutar:getDönemTutariSP(data.aidatTarihleri,sakin.siteId,key,sakin.aidatBedeli||800)});
          d2.setMonth(d2.getMonth()+1);
        }
        if(arr.length>0) aidatListesi=arr;
      }
      const arizalar = (data.arizalar||[]).filter(a=>a.sakinId===sakin.id||a.daireId===sakin.daireId);
      const sikayetler = (data.sakinSikayetler||[]).filter(s=>s.daireId===sakin.daireId||s.kAd===sakin.ad);
      // Mesajları app_data.veri içindeki siteMesajlar_X key'inden oku
      let mesajListesi = [];
      const chatKey = `siteMesajlar_${siteId}`;
      if (Array.isArray(data[chatKey])) {
        mesajListesi = data[chatKey];
      } else {
        // Mesajlar app_data'dan geliyor (siteMesajlar_X key'i)
      }
      setState(prev=>({
        ...prev,
        siteHarcamalar: siteHarcamalar.length>0?siteHarcamalar:prev.siteHarcamalar,
        duyurular: duyurular.length>0?duyurular:prev.duyurular,
        aidat: aidatListesi,
        mesajlar: mesajListesi,
        arizalar: arizalar.length>0?arizalar:prev.arizalar,
        sikayet: sikayetler.length>0?sikayetler:prev.sikayet,
      }));
    };
    yukle();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const siteBilgi   = siteBilgiState;
  const acilTelNo   = siteBilgi?.yoneticiTel || siteBilgi?.yonetici_tel || MOCK_SITE.acilTel;
  const acilYonetici = siteBilgi?.yonetici || MOCK_SITE.yonetici;

  if (!sakin) return <LoginScreen onLogin={handleLogin} t={t}/>;

  const renderSayfa = () => {
    switch(sayfa) {
      case "mesajlar":   return <Mesajlasma sakin={sakin} state={state} setState={setState} t={t} adminData={adminData}/>;
      case "aidat":      return <AidatTakibi sakin={sakin} state={state} setState={setState} t={t} adminData={adminData} />;
      case "harcamalar": return <SiteHarcamalari state={state} t={t}/>;
      case "duyurular":  return <Duyurular state={state} t={t}/>;
      case "ariza":      return <ArizaFormu sakin={sakin} state={state} setState={setState} t={t}/>;
      case "sikayet":    return <SikayetGorusAcil sakin={sakin} state={state} setState={setState} t={t} setAcilAcik={setAcilAcik}/>;
      case "profil":     return <ProfilDuzenle sakin={sakin} setSakin={setSakin} adminData={adminData} setAdminData={setAdminData} t={t}/>;
      default: return null;
    }
  };

  return (
    <div style={{minHeight:"100vh",background:"#f1f5f9",display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div className="sp-shell">
        {/* TOPBAR */}
        <div className="sp-top">
          <button onClick={()=>setSayfa("profil")} style={{background:"none",border:"none",padding:0,cursor:"pointer",flexShrink:0}} title="Profilim">
            <div className="sp-av" style={{border:sayfa==="profil"?"2px solid #3b82f6":"2px solid transparent"}}>{sakin.avatar}</div>
          </button>
          <div style={{flex:1}}>
            <div className="sp-name">{sakin.ad}</div>
            <div className="sp-site">{sakin.siteIsmi} · {sakin.blok} {t.block} {t.apartment}:{sakin.daireNo}</div>
          </div>
          <div className="sp-lang">
            {["TR","EN","RU"].map(l=><button key={l} className={`sp-lb ${lang===l?"on":""}`} onClick={()=>setLangPersist(l)}>{l}</button>)}
          </div>
          <button className="sp-logout" onClick={cikisYap} title={t.logout}>↩</button>
          <button className="sp-acil" onClick={()=>setAcilAcik(true)}>🚨</button>
        </div>

        {/* SAYFA */}
        <div className="sp-page">{renderSayfa()}</div>

        {/* BOTTOM NAV */}
        <nav className="sp-nav">
          {nav.map(n=>(
            <button key={n.id} className={`sp-nb ${sayfa===n.id?"on":""}`} onClick={()=>setSayfa(n.id)}>
              <Icon name={n.icon} size={20}/>
              {n.label}
            </button>
          ))}
        </nav>

        {acilAcik&&<AcilModal onClose={()=>setAcilAcik(false)} t={t} sakin={sakin} acilTelNo={acilTelNo} acilYonetici={acilYonetici}/>}
      </div>
    </div>
  );
}
